import { useContext, useEffect, useState } from "react";
import { AdminService } from "../../../../Services/Admin.service";
import { RequestorService } from "../../../../Services/Requestor.Service";
import { Table, Dropdown, DropdownButton, Pagination } from "react-bootstrap";
import { FaSearch } from "react-icons/fa";
import AdminListStatus from "../../../../Components/AdministrativeSettings/AdminListStatus";
import AdminListRole from "../../../../Components/AdministrativeSettings/AdminListRole";
import navdots from "../../../../Assets/images/navdots.svg";
import Toaster from "../../../../Components/Toaster";
import { Link } from "react-router-dom";
import AdminRoleDropdown from "../../../../Components/AdministrativeSettings/AdminRoleDropdown";
import AdminStatusDropdown from "../../../../Components/AdministrativeSettings/AdminStatusDropdown";

import SearchInput from "../../../../Components/AdministrativeSettings/SearchInput";
import AdminTableRow from "../../../../Components/AdministrativeSettings/AdminTableRow";
import TablePagination from "../../../../Components/AdministrativeSettings/TablePagination";
import RequestorTableRow from "../../../../Components/AdministrativeSettings/RequestorManagement/RequestorTableRow";
import TrainingCompletedDropdown from "../../../../Components/AdministrativeSettings/RequestorManagement/TrainingCompletedDropdown";
import NoListDataAvailable from "../../../../Components/NoListDataAvailable";
import LoadingComponent from "../../../../Components/LoadingComponent";
import Loader from "../../../../Components/Loader";
import TokenService from "../../../../Services/Token.service";
import { useMediaQuery } from "react-responsive";
import { FilterInfo } from "../../../../Contexts/FilterContext";
function RequestorListTable(props) {
    const [loading, setLoading] = useState(true);

    const [showToast, setShowToast] = useState(false);
    const [toastMessage, setToastMessage] = useState('');
    const [toastVariant, setToastVariant] = useState('');

    const [totalRequestors, setTotalRequestor] = useState(0);
    const [requestorList, setRequestorList] = useState([]);
    const [statuses, setStatuses] = useState([]);
    //   const [roles, setRoles] = useState([]);
    const [selectedStatuses, setSelectedStatuses] = useState([]);
    //   const [selectedRoles, setSelectedRoles] = useState([]);

    const [totalUsers, setTotalUsers] = useState(0);
    const [trainingStatuses, setTrainingStatuses] = useState([]);
    const [selectedTrainingStatuses, setSelectedTrainingStatuses] = useState([]);

    const [rowsPerPage, setRowsPerPage] = useState(10);
    const { adminManagementState, setAdminManagementState } = useContext(FilterInfo);
    
    // const [pagination, setPagination] = useState({ page: 1, limit: 10, offset: 0 });
    const [pagination, setPagination] = useState(adminManagementState);

    const [searchName, setSearchName] = useState("");
    const [isSearchInputVisible, setSearchInputVisible] = useState(false);

    //   const [searchEmail, setSearchEmail] = useState("");
    //   const [isSearchEmailVisible, setSearchEmailVisible] = useState(false);
    //   const [searchPhone, setSearchPhone] = useState("");
    //   const [isSearchPhoneVisible, setSearchPhoneVisible] = useState(false);
    //   const [searchId, setSearchId] = useState("");
    //   const [isSearchIdVisible, setSearchIdVisible] = useState(false);

    const { isClearFilter } = props;
    const { onFilterCountChange } = props;
    const { exportCsv } = props;
    useEffect(() => {
        if (isClearFilter) {
            setSelectedStatuses([]);
            setSelectedTrainingStatuses([]);
            setSearchName("");
            setSearchInputVisible(false);
            onFilterCountChange(0);
        }
    }, [isClearFilter]);


     // Calculate and update the filter count
  useEffect(() => {
    const count = [
      selectedStatuses.length > 0 ? 1 : 0, 
      selectedTrainingStatuses.length > 0 ? 1 : 0, 
      searchName ? 1 : 0, 
    ].reduce((sum, val) => sum + val, 0);

    onFilterCountChange(count);
  }, [   selectedStatuses, selectedTrainingStatuses, searchName]);

    useEffect(() => {
        if (exportCsv) {
            setLoading(true);
            const filters = {
                name: searchName,
                status: selectedStatuses,
                training: selectedTrainingStatuses,
            };
           
            RequestorService.exportRequestorList([filters])
                .then((response) => {
                    
                    if (response.success) {
                        setShowToast(true);
                        setToastMessage(response.message);
                        setToastVariant("success");

                        const downloadUrl = response.download_url;
                        const link = document.createElement('a');
                        link.href = downloadUrl;
                        // link.setAttribute('download', 'requestor_export.csv');
                        document.body.appendChild(link);
                        link.click();
                        document.body.removeChild(link);
                        setLoading(false);
                    } else {
                        setShowToast(true);
                        setToastMessage(response.message);
                        setToastVariant("danger");
                        setLoading(false);
                    }
                })
                .catch((error) => {
                    setShowToast(true);
                    setToastMessage("Error exporting requestor list.");
                    setToastVariant("danger");
                    console.error("Error exporting requestor list:", error);
                    setLoading(false);
                });
        }
    }, [exportCsv]);


    useEffect(() => {
        fetchStatuses();
        fetchTrainingStatuses();
    }, []);

    useEffect(() => {
        fetchRequestorList();
    }, [pagination, selectedStatuses, selectedTrainingStatuses, searchName]);
    //   selectedRoles, searchEmail, searchPhone, searchId

    function fetchRequestorList() {

        setLoading(true);
        const filters = {
            name: searchName,
            status: selectedStatuses,
            training: selectedTrainingStatuses,
        };

        const params = {
            limit: pagination.limit,
            offset: pagination.offset,
            filters: [filters],
        };

        RequestorService.getRequestorList(params)
            .then((response) => { 
                setRequestorList(response.data.list); 
                setTotalRequestor(response.data.total);
                setLoading(false);
            })
            .catch((error) => {
                console.error("Failed to fetch admin list", error);
                setLoading(false);
            });
    }

    function fetchStatuses() {
        AdminService.getAdminListStatusTypes()
            .then((statusTypes) => {
                setStatuses(statusTypes);

            })
            .catch((error) => {
                console.error("Failed to fetch status types", error);
            });
    }

    function fetchTrainingStatuses() {
        AdminService.getRequestorListTrainingStatusTypes()
            .then((trainingStatusTypes) => {
                setTrainingStatuses(trainingStatusTypes);

            })
            .catch((error) => {
                console.error("Failed to fetch status types", error);
            });
    }



    const handleStatusChange = (status) => {
        if (selectedStatuses.includes(status)) {
            setSelectedStatuses(selectedStatuses.filter((s) => s !== status));
        } else {


            setSelectedStatuses([...selectedStatuses, status]);
        }
        setPagination({ ...pagination, page: 1, offset: 0 });
        setAdminManagementState({ ...pagination, page: 1, offset: 0 });
    };
    const handleTrainingStatusChange = (trainingStatus) => {
        if (selectedTrainingStatuses.includes(trainingStatus)) {
            setSelectedTrainingStatuses(selectedTrainingStatuses.filter((s) => s !== trainingStatus));
        } else {


            setSelectedTrainingStatuses([...selectedTrainingStatuses, trainingStatus]);
        }
        setPagination({ ...pagination, page: 1, offset: 0 });
        setAdminManagementState({ ...pagination, page: 1, offset: 0 });
    };
    const handleChangeStatus = async (admin, status) => {
        setLoading(true);
        const newStatus = admin.active ? 0 : 1; // Determine the new status
        try {
            const response = await AdminService.changeUserStatus(admin.id, newStatus); // Pass the user ID and new status

            if (response.success == true) {
                setToastMessage(response.message);
                setShowToast(true);
                setToastVariant('success');
                fetchRequestorList();
                setLoading(false); 
            }
            else {
                setToastMessage(response.message);
                setShowToast(true);
                setToastVariant('error');
                setLoading(false); 
            }
        } catch (error) {
            setToastMessage("Failed to change user status");
            setShowToast(true);
            setToastVariant('error');
            console.error("Failed to change user status:", error);
            setLoading(false); 
        }
    };

    const handleDeleteUser = async (userId) => {
        try {
            const payload = {
                // admin_id : TokenService.getUserId(),
                requestor_id : userId,
            }
            const response = await AdminService.deleteRequestorUser(payload);

            if (response.success == true) {
                setToastMessage(response.message);
                setShowToast(true);
                setToastVariant('success');
                console.log("Requestor deleted successfully:", response);
                fetchRequestorList();
            }
            else {
                setToastMessage(response.message);
                setShowToast(true);
                setToastVariant('error');
            }
        } catch (error) {
            setToastMessage(error.response.data.message);
            setShowToast(true);
            setToastVariant('error');
            console.error("Failed to delete user:", error.response.data.message);
        }
    };

    const handleRowsPerPageChange = (newRowsPerPage) => {

        if (newRowsPerPage === 'Show All') {
            setRowsPerPage(totalRequestors);
            setPagination({ limit: totalRequestors, offset: 0, page: 1 });
            setAdminManagementState({ limit: totalRequestors, offset: 0, page: 1 });
        } else {
            setRowsPerPage(Number(newRowsPerPage));
            setPagination({ limit: Number(newRowsPerPage), offset: 0, page: 1 });
            setAdminManagementState({ limit: Number(newRowsPerPage), offset: 0, page: 1 });
        }
    };

    const totalFiltered = requestorList.length;  //ex 10 
    const totalPages = Math.ceil(totalRequestors / rowsPerPage); // 10 / 2rpp  then  5 pages

    const handleNextPage = () => {
        setPagination({ ...pagination, offset: pagination.page * rowsPerPage, page: pagination.page + 1 });
        setAdminManagementState({ ...pagination, offset: pagination.page * rowsPerPage, page: pagination.page + 1 });
    };

    const handlePreviousPage = () => {
        setPagination({ ...pagination, offset: (pagination.page - 2) * rowsPerPage, page: pagination.page - 1 });
        setAdminManagementState({ ...pagination, offset: (pagination.page - 2) * rowsPerPage, page: pagination.page - 1 });
    };
    const isMobile = useMediaQuery({ maxWidth: 768 });
    return (
        <div>
              {isMobile ? (
           <div className="admin-card-list mt-3">
            {requestorList.length > 0 ? (
                            
                            <div  className="row">   
                             {
                            requestorList.map((requestor, index) => (
                            <div className="col-sm-12 col-md-6 mb-3" key={requestor.id}>
                            <RequestorTableRow
                                key={index}
                                requestor={requestor}
                                handleChangeStatus={handleChangeStatus}
                                handleDeleteRequestor={handleDeleteUser}
                                fetchRequestorList={fetchRequestorList}
                            />
                            </div>
                        ))} 
                        </div>
                        ) : (<NoListDataAvailable type="requestor" />)}
         </div>
         ):(<>
            <Loader loading={loading}/>
            <div className="el-table-container el-board-table">
                <Table hover >
                    <thead>
                        <tr>
                            <th>
                                <SearchInput
                                    label="Requestor Name"
                                    value={searchName}
                                    setValue={setSearchName}
                                    isVisible={isSearchInputVisible}
                                    setVisible={setSearchInputVisible}
                                />
                            </th>
                            <th>
                                <div className="el-table-input">
                                    <label>Location</label>
                                </div>
                            </th>
                            <th>
                                <AdminStatusDropdown
                                    statuses={statuses}
                                    selectedStatuses={selectedStatuses}
                                    handleStatusChange={handleStatusChange}
                                    setSelectedStatuses={setSelectedStatuses}
                                    label = "Status"
                                />
                            </th>
                            <th>
                                <TrainingCompletedDropdown
                                    trainingStatuses={trainingStatuses}
                                    selectedTrainingStatuses={selectedTrainingStatuses}
                                    handleTrainingStatusChange={handleTrainingStatusChange}
                                    setSelectedTrainingStatuses={setSelectedTrainingStatuses} />
                            </th>
                            <th>Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                    {requestorList.length > 0 ? (requestorList.map((requestor, index) => (
                            <RequestorTableRow
                                key={index}
                                requestor={requestor}
                                handleChangeStatus={handleChangeStatus}
                                handleDeleteRequestor={handleDeleteUser}
                                fetchRequestorList={fetchRequestorList}
                            />
                        ))) : (<NoListDataAvailable type="requestor" />)}
                    </tbody>
                </Table>
            </div>
            </> 
        )}
            <TablePagination
                rowsPerPage={rowsPerPage}
                handleRowsPerPageChange={handleRowsPerPageChange}
                pagination={pagination}
                totalPages={totalPages}
                handlePreviousPage={handlePreviousPage}
                handleNextPage={handleNextPage}
                totalUsers={totalRequestors}
            />
            <Toaster
                show={showToast}
                message={toastMessage}
                variant={toastVariant}
                onClose={() => setShowToast(false)}
            />
        </div>
    );
}
export default RequestorListTable;
